import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import Lottie from "react-lottie";
import { Container } from "reactstrap";
import * as loadingPerson from "./loadingPerson.json";

function LoadingPerson() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingPerson.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  //   const [loading, setLoading] = useState(false);

  //   useEffect(() => {
  //     setTimeout(() => {
  //       setLoading(true);
  //     }, 3000);
  //   }, []);

  return (
    <React.Fragment>
      {/* {!loading ?  */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {" "}
        <FadeIn>
          <Lottie options={defaultOptions} width={400} height={200} />
        </FadeIn>
      </div>

      {/* // : null} */}
    </React.Fragment>
  );
}

export default LoadingPerson;
